import { BodyText } from '@unmind/design-system-components-web';
import { Office, Review, SolidLifebuoy, SolidLock, Sparkles } from 'icons';
import { css, styled } from 'styles';

export const AboutModalTitleContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.sheet.background};
  color: ${({ theme }) => theme.colors.text.primary};
  padding: 24px 20px;
`;

export const AboutModalTitleText = styled(BodyText).attrs(({ theme }) => ({
  color: theme.colors.text.primary,
  sizes: [theme.typography.fontSizes.fontSize18],
  weight: theme.typography.fontWeights.semiBold,
}))``;

export const AboutModalContentContainer = styled.div`
  padding: 0 20px 8px 20px;
  background-color: ${({ theme }) => theme.colors.sheet.background};
`;

export const AboutModalBodyText = styled(BodyText).attrs(({ theme }) => ({
  color: theme.colors.text.primary,
  sizes: [theme.typography.fontSizes.fontSize14],
}))``;

export const DisclaimerContainerWrapper = styled.div<{
  $inModal: boolean;
}>`
  ${({ $inModal }) =>
    !$inModal &&
    css`
      & > div:last-child {
        padding-bottom: 0;
      }
    `}
`;

export const DisclaimerContainer = styled.div<{
  isFirst?: boolean;
  isLast?: boolean;
}>`
  display: flex;
  flex-direction: row;
  padding-bottom: 16px;

  ${({ isLast, theme }) =>
    !isLast &&
    css`
      border-bottom: 1px solid ${theme.colors.border.secondary};
    `}
  ${({ isFirst }) =>
    !isFirst &&
    css`
      padding-top: 16px;
    `};
`;

export const DisclaimerText = styled(BodyText).attrs(({ theme }) => ({
  color: theme.colors.text.primary,
  sizes: [theme.typography.fontSizes.fontSize14],
}))`
  flex: 1;
`;

export const DisclaimerLink = styled.a.attrs(({ theme }) => ({
  sizes: [theme.typography.fontSizes.fontSize14],
  weight: theme.typography.fontWeights.semiBold,
}))`
  color: ${({ theme }) => theme.colors.text.primary};
  text-decoration-line: underline;
  text-decoration-color: ${({ theme }) => theme.colors.text.primary};
`;

export const DisclaimerIconContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-right: 8px;
`;

const iconStyles = {
  width: 16,
  height: 16,
};

export const AIGeneratedIcon = styled(Sparkles).attrs(({ theme }) => ({
  primaryColor: theme.colors.text.primary,
  ...iconStyles,
}))``;

export const MedicalDisclaimerIcon = styled(SolidLifebuoy).attrs(
  ({ theme }) => ({
    primaryColor: theme.colors.text.primary,
    ...iconStyles,
  }),
)``;

export const OfficeIcon = styled(Office).attrs(({ theme }) => ({
  primaryColor: theme.colors.text.primary,
  ...iconStyles,
}))``;

export const ConfidentialityIcon = styled(SolidLock).attrs(({ theme }) => ({
  primaryColor: theme.colors.text.primary,
  ...iconStyles,
}))``;

export const AnonymityIcon = styled(Review).attrs(({ theme }) => ({
  primaryColor: theme.colors.text.primary,
  ...iconStyles,
}))``;
